// Build a URL query string from an object, dropping null/undefined/empty values.
// Used by every API call so callers don't have to copy the same cleanup five times.
export function toQuery(params) {
  if (!params) return '';
  const clean = {};
  for (const [k, v] of Object.entries(params)) {
    if (v === null || v === undefined || v === '') continue;
    clean[k] = v;
  }
  const qs = new URLSearchParams(clean).toString();
  return qs ? `?${qs}` : '';
}
